export default "__VITE_PUBLIC_ASSET__2d29a66c__"